import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Flower2, Sparkles } from 'lucide-react';
import { mockData } from '../mock';
import SEO from '../components/SEO';

const Home = () => {
  const { doula, testimonials, services } = mockData;

  return (
    <div className="home-page">
      <SEO 
        title="12 Tribes Doula Services | Holistic Birth Support for Black Mothers in Central Georgia"
        description="Professional doula services for Black mothers in Macon, Warner Robins & Central Georgia. Holistic birth support, herbal consultations, natural healing, prenatal & postpartum care."
        keywords="doula Central Georgia, Black doula Macon GA, birth doula Warner Robins, holistic birth support Georgia, natural birth doula, postpartum care Central Georgia, herbal doula services"
        url="https://georgia-birth-coach.preview.emergentagent.com"
      />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-image-overlay">
          <img 
            src="https://images.unsplash.com/photo-1639236301225-6080d79a7299?auto=format&fit=crop&q=80&w=1200" 
            alt="Peaceful pregnant Black woman" 
            className="hero-bg-image"
          />
        </div>
        <div className="hero-content">
          <div className="hero-announcement">
            <Sparkles size={14} />
            <span>Serving Central Georgia</span>
          </div>
          <h1 className="heading-hero">{doula.tagline}</h1>
          <p className="body-large hero-subtitle">
            Holistic birth support rooted in ancestral wisdom, natural healing, and deep reverence for Black motherhood.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary">Book Consultation</Link>
            <Link to="/services" className="btn-secondary">Explore Services</Link>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="values-grid">
            <div className="value-card">
              <Heart size={32} className="value-icon" />
              <h3 className="heading-3">Culturally-Centered Care</h3>
              <p className="body-small">Honoring the strength and beauty of Black motherhood with care that sees and celebrates you.</p>
            </div>
            <div className="value-card">
              <Flower2 size={32} className="value-icon" />
              <h3 className="heading-3">Holistic Healing</h3>
              <p className="body-small">Natural remedies, herbs, and teas that nurture your body, mind, and spirit throughout your journey.</p>
            </div>
            <div className="value-card">
              <Sparkles size={32} className="value-icon" />
              <h3 className="heading-3">Ancestral Wisdom</h3>
              <p className="body-small">Drawing from traditional practices passed down through generations of Black healers and midwives.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">How I Support You</h2>
            <p className="body-medium">Comprehensive doula care for every stage of your journey</p>
          </div>
          <div className="voice-grid">
            {services.slice(0, 3).map((service) => (
              <div key={service.id} className={`voice-card ${service.accentClass}`}>
                <h3 className="voice-card-title">{service.title}</h3>
                <p className="voice-card-description">{service.description}</p>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <Link to="/services" className="btn-primary">View All Services</Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="heading-1">Stories from Our Sisters</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <p className="body-small" style={{fontWeight: 500}}>{testimonial.name}</p>
                  <p className="caption">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1">Ready to Begin Your Journey?</h2>
            <p className="body-large">Let's create a birth experience that honors you, your baby, and your story.</p>
            <Link to="/contact" className="btn-primary">Schedule a Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
